import { render, staticRenderFns } from "./satlabortypes.vue?vue&type=template&id=4e19872c&scoped=true&lang=pug"
import script from "./satlabortypes.vue?vue&type=script&lang=js"
export * from "./satlabortypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19872c",
  null
  
)

/* custom blocks */
import block0 from "./satlabortypes.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports